import { resetAddress } from '../../store/address/addressSlice'
import PageNotFoundError from '../../domain/error/PageNotFoundError'
import { POPUP_TYPE_ADDRESS } from '../../domain/map/popup/popup.selectors'
import { renderPage } from '../../domain/traffic/trafficCity.page'
import { searchAddress } from '../../store/address/address.actions'
import { displayMapPopup, setMapMode } from '../../store/map/mapSlice'
import { MAP_MODES } from '../../store/map/map.constants'
import { selectIsFrenchSite } from '../../store/navigation/navigation.selectors'
import { resetSearchTerms, setSearchTerms } from '../../store/search/searchSlice'
import { searchSeoCityData } from '../../store/seo/seo-address.actions'
import {
  redirectCityRouteIfDifferentPostcode,
  redirectCityRouteIfTownUpperCased,
  redirectIfStartsWithDash,
  searchLayerCityDescription
} from '../../store/seo/seo-city.actions'
import { loadSeoLayerFaq } from '../../store/seo/seo-faq.actions'
import { loadSeoPoisForCity } from '../../store/seo/seo-poi.actions'
import { ROUTE_TRAFFIC_CITY } from '../index'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params, store: { dispatch, getState } }) => {
  if (!selectIsFrenchSite(getState())) throw new PageNotFoundError('info-trafic accessed from foreign site')

  const { location } = params

  if (__SERVER__) {
    redirectIfStartsWithDash(location)
    redirectCityRouteIfTownUpperCased(location, ROUTE_TRAFFIC_CITY)
  }

  dispatch(resetAddress())
  dispatch(setMapMode(MAP_MODES.traffic))
  dispatch(resetSearchTerms())
  dispatch(setSearchTerms(location))

  return Promise.resolve()
    .then(() =>
      searchAddress({
        terms: location,
        options: {
          avoidRedirect: true
        }
      })(dispatch, getState)
    )
    .then(() => {
      if (__SERVER__) {
        redirectCityRouteIfDifferentPostcode(location, ROUTE_TRAFFIC_CITY)(dispatch, getState)
        return Promise.all([
          searchSeoCityData()(dispatch, getState).then(() =>
            Promise.all([
              loadSeoPoisForCity({ ovmLimit: 30 })(dispatch, getState),
              searchLayerCityDescription(MAP_MODES.traffic)(dispatch, getState)
            ])
          ),
          loadSeoLayerFaq('traffic-city')(dispatch, getState)
        ])
      }
    })
    .then(() => {
      dispatch(displayMapPopup(POPUP_TYPE_ADDRESS))
    })
}

export default handleRouteLoading({ onRouteEnter, renderPage })
